<template>
  <div>
    <router-view></router-view>
    <!-- Smart Search (Cmd+K / Ctrl+K) -->
    <SmartSearch v-if="isEnabled"/>
    <!-- AI Assistant Widget -->
    <AIAssistantWidget v-if="isEnabled" />
    <AIAssistantButton v-if="isEnabled"/>
    <!-- Error Resolver -->
    <ErrorResolver v-if="isEnabled"/>
    <!-- Workflow Guide -->
    <WorkflowGuide v-if="isEnabled" />
    <!-- Location Debug (Development Only) -->
    <FloatingLocationDebug v-if="isEnabled" />
  </div>
</template>

<script>
import AIAssistantWidget from '@/components/ai-assistant/AIAssistantWidget.vue';
import AIAssistantButton from '@/components/ai-assistant/AIAssistantButton.vue';
import ErrorResolver from '@/components/ai-assistant/ErrorResolver.vue';
import SmartSearch from '@/components/ai-assistant/SmartSearch.vue';
import WorkflowGuide from '@/components/ai-assistant/WorkflowGuide.vue';
import FloatingLocationDebug from '@/components/common/FloatingLocationDebug.vue';

export default {
  name: "App",

  data() {
    return {
      isEnabled: false,
    };
  },
  
  components: {
    AIAssistantWidget,
    AIAssistantButton,
    ErrorResolver,
    SmartSearch,
    WorkflowGuide,
    FloatingLocationDebug,
  },
  
  methods: {
    toggleAssistant() {
      this.isEnabled = !this.isEnabled;
    },
  }
};
</script>
